import { render, staticRenderFns } from "./DraggableAccordion.vue?vue&type=template&id=229e6b3c&scoped=true"
import script from "./DraggableAccordion.vue?vue&type=script&lang=js"
export * from "./DraggableAccordion.vue?vue&type=script&lang=js"
import style0 from "./DraggableAccordion.vue?vue&type=style&index=0&id=229e6b3c&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229e6b3c",
  null
  
)

export default component.exports